import { Link } from "react-router-dom";
import { Phone, MessageSquare } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { Field, inputProps, ChoiceButton } from "./Field";

export const StepContact = ({ draft, update, setDraft, errors }) => {
  const { t } = useLang();
  const c = draft.customer;
  const set = (patch) => update("customer", patch);
  return (
    <fieldset className="space-y-6">
      <legend className="text-xl sm:text-2xl font-extrabold uppercase">{t("wizard.contactTitle")}</legend>
      <div className="grid gap-4 sm:grid-cols-2">
        <Field id="customer-name" label={t("wizard.name")} error={errors["customer.name"]} required>
          <input {...inputProps("customer-name", errors["customer.name"])} value={c.name} maxLength={100} autoComplete="name" autoCapitalize="words" onChange={(e) => set({ name: e.target.value })} />
        </Field>
        <Field id="customer-phone" label={t("wizard.phone")} error={errors["customer.phone"]} required>
          <input {...inputProps("customer-phone", errors["customer.phone"])} type="tel" inputMode="tel" autoComplete="tel" maxLength={20} placeholder={t("wizard.phonePh")} value={c.phone} onChange={(e) => set({ phone: e.target.value })} />
        </Field>
      </div>
      <div>
        <p className="mb-2 text-sm font-semibold text-gray-200">{t("wizard.method")} <span className="text-[#DC2626]">*</span></p>
        <div role="radiogroup" className="grid grid-cols-2 gap-3 max-w-md">
          <ChoiceButton selected={c.contact_method === "call"} onClick={() => set({ contact_method: "call" })} testId="contact-method-call" className="flex items-center justify-center gap-2"><Phone className="h-4 w-4" /> {t("wizard.call")}</ChoiceButton>
          <ChoiceButton selected={c.contact_method === "text"} onClick={() => set({ contact_method: "text" })} testId="contact-method-text" className="flex items-center justify-center gap-2"><MessageSquare className="h-4 w-4" /> {t("wizard.text")}</ChoiceButton>
        </div>
      </div>
      <details open={!!errors["customer.email"] || undefined} className="rounded-xl border border-[#2E2E3A] bg-[#0E0E12] p-4" data-testid="contact-more-details">
        <summary className="cursor-pointer text-sm font-semibold text-[#FACC15]" data-testid="contact-more-toggle">{t("wizard.moreContact")}</summary>
        <div className="mt-4 space-y-4">
      <Field id="customer-email" label={t("wizard.email")} error={errors["customer.email"]}>
        <input {...inputProps("customer-email", errors["customer.email"])} type="email" inputMode="email" autoComplete="email" maxLength={200} value={c.email} onChange={(e) => set({ email: e.target.value })} />
      </Field>
      <Field id="customer-notes" label={t("wizard.contactNotes")}>
        <textarea {...inputProps("customer-notes")} rows={2} maxLength={600} value={c.contact_notes} placeholder={t("wizard.contactNotesPh")} onChange={(e) => set({ contact_notes: e.target.value })} />
      </Field>
        </div>
      </details>
      <div className="rounded-xl border border-[#2E2E3A] bg-[#0E0E12] p-4">
        <label className="flex items-start gap-3 cursor-pointer text-sm text-gray-200">
          <input type="checkbox" className="mt-0.5 h-5 w-5 shrink-0 accent-[#FACC15]" checked={draft.consent} onChange={(e) => setDraft((d) => ({ ...d, consent: e.target.checked }))} data-testid="consent-checkbox" aria-invalid={errors.consent ? "true" : "false"} />
          <span>{t("wizard.consent")}</span>
        </label>
        {errors.consent && <p role="alert" className="mt-2 text-sm text-red-400" data-testid="consent-error">{t(errors.consent)}</p>}
        <p className="mt-3 text-xs text-gray-500">{t("wizard.privacyNote")} <Link to="/privacy" target="_blank" className="underline hover:text-white">{t("wizard.privacyLink")}</Link>.</p>
      </div>
    </fieldset>
  );
};
